import { BugNoteGeneratedEntity } from "./generated/BugNoteGeneratedEntity";

export abstract class BugNoteEntity extends BugNoteGeneratedEntity {
    // Comment to preserve new line
}